import axios from 'axios';
export function initClient(baseURL, useAdapter) {
    const client = axios.create({ baseURL });
    if (useAdapter) {
        client.defaults.adapter = function (config) {
            return fetch(config.baseURL + config.url, {
                method: config.method,
                headers: config.headers,
                body: config.data,
                credentials: config.withCredentials ? 'include' : undefined
            }).then(response => response.text().then(text => ({
                data: text,
                status: response.status,
                statusText: response.statusText,
                headers: response.headers,
                config: config,
                request: fetch
            }))).catch(function (reason) {
                throw reason;
            });
        };
    }
    return client;
}
